import  { createContext } from 'react';

const CourseRefreshContext = createContext();
export default CourseRefreshContext ;